import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateAhjFeeScheduleMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  set: Types.Ahj_Fee_Schedules_Set_Input;
}>;


export type UpdateAhjFeeScheduleMutation = { __typename?: 'mutation_root', update_ahj_fee_schedules_by_pk?: { __typename?: 'ahj_fee_schedules', id: any } | null };


export const UpdateAhjFeeScheduleDocument = gql`
    mutation updateAhjFeeSchedule($id: uuid!, $set: ahj_fee_schedules_set_input!) {
  update_ahj_fee_schedules_by_pk(pk_columns: {id: $id}, _set: $set) {
    id
  }
}
    `;
export type UpdateAhjFeeScheduleMutationFn = Apollo.MutationFunction<UpdateAhjFeeScheduleMutation, UpdateAhjFeeScheduleMutationVariables>;

/**
 * __useUpdateAhjFeeScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateAhjFeeScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAhjFeeScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAhjFeeScheduleMutation, { data, loading, error }] = useUpdateAhjFeeScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdateAhjFeeScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAhjFeeScheduleMutation, UpdateAhjFeeScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAhjFeeScheduleMutation, UpdateAhjFeeScheduleMutationVariables>(UpdateAhjFeeScheduleDocument, options);
      }
export type UpdateAhjFeeScheduleMutationHookResult = ReturnType<typeof useUpdateAhjFeeScheduleMutation>;
export type UpdateAhjFeeScheduleMutationResult = Apollo.MutationResult<UpdateAhjFeeScheduleMutation>;
export type UpdateAhjFeeScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateAhjFeeScheduleMutation, UpdateAhjFeeScheduleMutationVariables>;